import { OnInit, ChangeDetectorRef, EventEmitter, TemplateRef, ElementRef } from '@angular/core';
import { GalleryColumns } from '../../models/gallery-list-columns.enum';
import { environment } from 'src/environments/environment';
import { GalleryViewMode } from '../../models/gallery-view-mode.enum';
var GalleryResultsComponent = /** @class */ (function () {
    function GalleryResultsComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.galleryViewMode = GalleryViewMode;
        this.loading = false;
        this.viewMode = GalleryViewMode.Cards;
        this.selectLabel = 'Select';
        this.checkable = false;
        this.showActions = false;
        this.checkedResults = [];
        this.selectBookmark = new EventEmitter();
        this.checkedChange = new EventEmitter();
    }
    Object.defineProperty(GalleryResultsComponent.prototype, "results", {
        get: function () {
            return this._results;
        },
        set: function (value) {
            this._results = value;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    GalleryResultsComponent.prototype.ngOnInit = function () {
        switch (environment.exportType) {
            case 'bookmark':
                this.columns = [
                    GalleryColumns.Model,
                    GalleryColumns.Tags,
                    GalleryColumns.CreatedBy,
                    GalleryColumns.UpdatedBy,
                    GalleryColumns.Actions
                ];
                break;
            case 'module':
                this.columns = [
                    GalleryColumns.Model,
                    GalleryColumns.Actions
                ];
                break;
        }
    };
    GalleryResultsComponent.prototype.handleSelect = function (result) {
        this.selectBookmark.emit(result);
    };
    GalleryResultsComponent.prototype.handleCheckedChange = function (ids) {
        this.checkedChange.emit(ids);
    };
    return GalleryResultsComponent;
}());
export { GalleryResultsComponent };
